import _ from 'lodash';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import Api from '../../services/ApiService';
import ListSearch from '../list/ListSearch';
import { FormContainerContext } from '../form/Form';

const CustomerVehicleSearch = props => {
  const { branchId } = useContext(FormContainerContext);

  const getSuggestionValue = suggestion => {
    if (suggestion.empty) {
      return '';
    }

    return suggestion.itemid;
  };

  const loadSuggestions = value => {
    const { pageName, command, limit, validationKeyValue } = props;

    const params = {
      cmd: command,
      q: value || '',
      limit,
      terms: {},
    };

    if (validationKeyValue) {
      params.terms['Customer.keyword'] = [validationKeyValue];
    }

    if (!params.terms['Customer.keyword']) {
      params.terms['CusActive.keyword'] = ['Active'];
    }

    params.terms = Buffer.from(JSON.stringify(params.terms)).toString('base64');

    if (branchId) {
      params.useBranchId = branchId;
    }

    props.setLoading(true);

    return Api.get(`/list/${pageName}`, { params }).then(response => {
      return new Promise(resolve => {
        if (_.isEmpty(response.data.list)) {
          resolve([{ empty: 'No Vehicles' }]);
        } else {
          resolve(response.data.list);
        }
        props.setLoading(false);
      });
    });
  };

  const renderSuggestion = (suggestion, { query }) => {
    if (suggestion.empty) {
      return <div>{suggestion.empty}</div>;
    }

    const result = {};

    const style = {
      fontSize: '12px',
    };

    ['itemid', 'Make', 'Model', 'Year', 'Type', 'Customer', 'Customer Name', 'License', 'Unit Number'].forEach(part => {
      result[part] = suggestion[part];
      if (result[part]) {
        result[part] = (
          <Highlighter
            autoEscape
            highlightClassName="hl"
            searchWords={query.replace(':', '').split(/\s/)}
            textToHighlight={`${suggestion[part]}`}
          />
        );
      }
    });

    return (
      <div>
        <div>
          <b>{result.itemid}</b> ({result.Type})
        </div>
        {(result.Year || result.Make || result.Model) && (
          <div style={style}>
            {result.Year} {result.Make} {result.Model}
          </div>
        )}
        {(result['Customer Name'] || result.Customer) && (
          <div style={style}>
            {result['Customer Name']} ({result.Customer})
          </div>
        )}
        {result['Unit Number'] && <div style={style}>Unit: {result['Unit Number']}</div>}
        {result.License && <div style={style}>License: {result.License}</div>}
      </div>
    );
  };

  return (
    <ListSearch
      {...props}
      getSuggestionValue={getSuggestionValue}
      loadSuggestions={loadSuggestions}
      renderSuggestion={renderSuggestion}
      validationKeyValue={undefined}
    />
  );
};

CustomerVehicleSearch.defaultProps = {
  command: 'LIST',
  limit: 25,
  setLoading: () => {},
};

CustomerVehicleSearch.propTypes = {
  command: PropTypes.string,
  limit: PropTypes.number,
  pageName: PropTypes.string,
  setLoading: PropTypes.func,
  validationKeyValue: PropTypes.string,
};

export default CustomerVehicleSearch;
